import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
import { StudentQuizChallengeStatus } from '@edtech-ui/constants/student-quiz-challenges.enum';
import { StudentQuizChallenge } from '@edtech-ui/core/models/student-courses-v2/student-quiz-challanges';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { DateService } from '@edtech-ui/core/services/dateService/date.service';
import { StudentCoursesService } from '@edtech-ui/core/services/student-courses/student-courses.service';
import { QuizDialogComponent } from '@edtech-ui/dashboard/student/quiz/quiz-dialog/quiz-dialog.component';
import { ViewQuizResultDialogComponent } from '@edtech-ui/dashboard/student/quiz/view-quiz-result-dialog/view-quiz-result-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-course-daily-challenge',
	standalone: true,
	imports: [CommonModule, MatProgressSpinnerModule, MatTooltipModule, HasPermissionDirective],
	templateUrl: './course-daily-challenge.component.html',
	styleUrl: './course-daily-challenge.component.scss'
})
export class CourseDailyChallengeComponent implements OnInit, OnDestroy {

	isChallengeStarted = false;
	isLoading = false;
	subscription = new Subscription();
	courseId!: string;
	classId!: number;
	studentQuizChallenge: StudentQuizChallenge[] = [];
	StudentQuizChallengeStatus = StudentQuizChallengeStatus;
	dateFormat = DateService.APP_DATE_TIME_SHORT;
	totalQuizPages = 10;
	page = 1;
	pageSize = 10;
	limit = 10;
	PermissionForStudents = PermissionForStudents;

	startChallenge() {
		this.isChallengeStarted = true;
	}
	constructor(
		private router: Router,
		private _toastr: ToastrService,
		private _studentCourseService: StudentCoursesService,
		private dialog: MatDialog,
		private route: ActivatedRoute,
		private _authService: AuthServiceService
	) { }

	ngOnInit(): void {
		this.classId = Number(this.route.parent?.snapshot.paramMap.get('classId')!);
		this.courseId = this.route.parent?.snapshot.paramMap.get('courseId')!;
		if (this.courseId && this._authService.hasPermission(PermissionForStudents.QUIZ_VIEW)) {
			this.getStudentQuizChallenges();
		}
	}

	getStudentQuizChallenges() {
		this.isLoading = true;
		this.subscription.add(
			this._studentCourseService.getStudentQuizChallenges(this.courseId, this.page, this.limit).pipe(
				tap(response => {
					if (response.Success) {
						this.studentQuizChallenge = [...response.Data.completed, ...response.Data.in_progress, ...response.Data.pending];
					} else {
						this._toastr.error(response.Message);
						this.router.navigate(['student-dashboard/course-details', this.courseId]);
					}
				}),
				finalize(() => {
					this.isLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong.Please try again');
					return of(null);
				}),
			).subscribe()
		)
	}


	openTakeQuizPopup(quiz: StudentQuizChallenge) {
		this.dialog.open(QuizDialogComponent, {
			width: '100%',
			maxWidth: '440px',
			panelClass: 'custom-dialog-panel',
			disableClose: true,
			data: { quizId: quiz.quiz_id }
		}).afterClosed().subscribe(result => {

			if (result?.started) {
				this.router.navigate(['quiz', result.quizId],
					{ relativeTo: this.route.parent, queryParams: { attemptId: result.attemptId }, state: { isResume: false } });
			}
		});
	}

	goToQuizDetailPage(quizId: string, attemptId: string | null) {
		this.router.navigate(['quiz', quizId], { relativeTo: this.route.parent, queryParams: { attemptId }, state: { isResume: true } });
	}

	viewQuizResult(quiz: StudentQuizChallenge) {
		if (!quiz.attempt_id) {
			this._toastr.error('Attempt ID is missing for this quiz.');
			return;
		}

		this.dialog.open(ViewQuizResultDialogComponent, {
			width: 'auto',
			maxWidth: 'none',
			panelClass: 'custom-dialog-panel',
			disableClose: true,
			data: {
				quizId: quiz.quiz_id,
				attemptId: quiz.attempt_id,
				status: quiz.status,
				score: quiz.score,
				classId: this.classId,
				courseId: this.courseId
			}
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}